import React from 'react';
import classNames from 'classnames';

export const Row = ({ className, ...props }: React.ComponentProps<'div'>) => {
  return (
    <div
      className={classNames('flex border-b border-[#fafafa]', className)}
      {...props}
    />
  );
};

export const RowHeader = ({
  className,
  ...props
}: React.ComponentProps<'div'>) => {
  return (
    <Row
      className={classNames(
        'text-black/85 font-medium text-left border-b-gray-200',
        className
      )}
      {...props}
    />
  );
};

type CellProps = {
  width?: number;
};

export const Cell = ({
  className,
  width,
  style,
  ...props
}: React.ComponentProps<'div'> & CellProps) => {
  return (
    <div
      className={classNames('flex p-2', className)}
      style={{
        ...style,
        flexBasis: width ? `${width}px` : '100%',
      }}
      {...props}
    />
  );
};
